export const REACT_APP_BASE_URL_USERS = window?._env_?.REACT_APP_BASE_URL_USERS;
export const REACT_APP_BASE_URL_LAYOUT = window?._env_?.REACT_APP_BASE_URL_LAYOUT;
export const REACT_APP_BASE_URL_CATALOG = window?._env_?.REACT_APP_BASE_URL_CATALOG;
export const REACT_APP_BASE_URL_DOCUMENTS = window?._env_?.REACT_APP_BASE_URL_DOCUMENTS;
export const REACT_APP_BASE_URL_CLIENTS = window?._env_?.REACT_APP_BASE_URL_CLIENTS;
export const REACT_APP_BASE_URL_LOG = window?._env_?.REACT_APP_BASE_URL_LOG;
export const REACT_APP_BASE_URL_SECURITY = window?._env_?.REACT_APP_BASE_URL_SECURITY;
export const REACT_APP_BASE_URL_KEYCLOAK = window?._env_?.REACT_APP_BASE_URL_KEYCLOAK;
export const REACT_APP_KEYCLOAK_REALM = window?._env_?.REACT_APP_KEYCLOAK_REALM;
export const REACT_APP_BASE_URL_VALIDATIONS = window?._env_?.REACT_APP_BASE_URL_VALIDATIONS;
export const REACT_APP_GA_ID = window?._env_?.REACT_APP_GA_ID;
export const REACT_APP_KEYCLOAK_CLIENT_ID = window?._env_?.REACT_APP_KEYCLOAK_CLIENT_ID;
export const REACT_APP_BASE_URL_REPORT = window?._env_?.REACT_APP_BASE_URL_REPORT;

